import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import XplorerTable from '@blade-sxp/pass/components/xplorer-table.vue';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
import { StaffModule } from '@blade-sxp/pass/store/staff';
import { EType } from '@blade/common/interfaces/user-group';
import EditMessages from '@blade-sxp/pass/lang/edit';
import { handleError } from '@blade/common/utils/handle-error';
let default_1 = class default_1 extends Vue {
    childId;
    pagination = {
        page: 1,
        size: 10,
        total: 0,
    };
    whiteStaff = [];
    listLoading = false;
    params = {
        dateEnd: '',
        dateStart: '',
        keywords: '',
        personGroup: EType.BLACKLIST,
        relation: true,
        sort: 'DESC',
        libId: [],
    };
    portraitsToExport = [];
    groupFilters = [];
    handleUpload() {
        this.$router.push('/traffic/staff/black/upload');
    }
    handleSizeChange(size) {
        this.pagination.size = size;
        this.pagination.page = 1;
        this.getData();
    }
    handleCurrentChange(curr) {
        this.pagination.page = curr;
        this.getData();
    }
    handleFullScreen() {
        document.body.requestFullscreen();
    }
    handleRefresh() {
        this.getData();
    }
    handleSelectionChange(val) {
        console.log('val:', val);
        this.portraitsToExport = val.map((item) => item.portraitId);
    }
    handleCreate() {
        this.$router.push('/traffic/staff/black/black-create');
    }
    handleEdit(row) {
        this.$router.push(`/traffic/staff/black/black-edit/${row.portraitId}`);
    }
    async mounted() {
        await this.getGroup();
        this.getData();
        this.$refs['staff-table'] && this.$refs['staff-table'].clearSelection();
        this.params.libId.push(...this.childId);
    }
    async getGroup() {
        try {
            const res = await StaffModule.getPortraitsGroup({ data: EType.BLACKLIST, mode: 'CREATE' });
            this.groupFilters = res.data?.map((item) => ({ text: item.name, value: item.libId }));
        }
        catch (e) { }
    }
    async getData() {
        this.listLoading = true;
        try {
            const res = await StaffModule.getPassportraits({ ...this.params, page: this.pagination.page, size: this.pagination.size });
            // console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = this.mapId(list);
            this.pagination.total = total;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    mapId(list) {
        const res = list.map((item) => {
            const mappedStaff = { id: item.portraitId, ...item };
            return mappedStaff;
        });
        return res;
    }
    async handleSearch(search) {
        this.listLoading = true;
        try {
            const { keywords, ...rest } = this.params;
            const res = await StaffModule.getPassportraits({ ...rest, keywords: search, page: 1, size: this.pagination.size });
            console.log('res:', res);
            const { list, total } = res.data;
            this.whiteStaff = list;
            this.pagination.total = total;
            this.pagination.page = 1;
            this.listLoading = false;
        }
        catch (e) {
            this.listLoading = false;
        }
    }
    handleDelete(row) {
        this.$confirm(`${this.$t('deleteUser').toString()} ${row.name}?`, 'Warning', {
            confirmButtonText: this.$t('confirm').toString(),
            cancelButtonText: this.$t('cancel').toString(),
            type: 'warning',
        })
            .then(async () => {
            try {
                await StaffModule.deletePortrait(row.portraitId);
                this.$elmessage.success(this.$t('deleteSuccess').toString());
                this.getData();
            }
            catch (e) {
                handleError(e);
            }
        })
            .catch(() => { });
    }
    async handleExport() {
        if (!this.portraitsToExport || this.portraitsToExport.length === 0) {
            this.$message.warning(this.$t('selections').toString());
            return;
        }
        try {
            const res = await StaffModule.exportPortraits({ libraryType: 0, portraitIds: this.portraitsToExport });
            this.$alert(this.$t('common.csv').toString(), '', {
                confirmButtonText: this.$t('common.confirm').toString(),
                callback: (action) => {
                    if (action === 'confirm') {
                        const path = process.env.NODE_ENV === 'development' ? `http://10.8.10.21:31234${res.data}` : res.data;
                        window.location.href = path;
                    }
                },
            });
        }
        catch (error) {
            this.$message({ type: 'error', message: error });
        }
    }
    handleFilter(filters) {
        this.params.libId = filters.group;
        this.getData();
    }
};
__decorate([
    Prop({ type: Array })
], default_1.prototype, "childId", void 0);
default_1 = __decorate([
    Component({
        name: 'portrait',
        components: { AuthItem, XplorerTable },
        i18n: {
            messages: {
                'en-us': {
                    name: 'Name',
                    id: 'ID Number',
                    portrait: 'ID Portrait',
                    group: 'User Group',
                    ppl: 'Creator',
                    update: 'Update',
                    visitpurpose: 'Visit purpose',
                    visitor: 'User group',
                    state: 'Status',
                    valid: 'Valid until',
                    creator: 'Creator',
                    deleteUser: 'Are you sure to delete ',
                    confirm: 'OK',
                    cancel: 'Cancel',
                    deleted: 'Delete successfully',
                    selections: 'No row selected',
                },
                zh: {
                    name: '姓名',
                    id: 'ID 号',
                    portrait: '证件头像',
                    group: '人员组',
                    ppl: '创建人',
                    update: '更新时间',
                    visitpurpose: '访问目的',
                    visitor: '访客组',
                    state: '访客状态',
                    valid: '访问有效期',
                    creator: '创建人',
                    deleteUser: '确认删除 ',
                    confirm: '确认',
                    cancel: '取消',
                    deleted: '成功删除',
                    selections: '没有选择导出列',
                },
            },
            sharedMessages: EditMessages,
        },
    })
], default_1);
export default default_1;
